import { render, staticRenderFns } from "./HistoricoRegistro.vue?vue&type=template&id=5352c806&"
import script from "./HistoricoRegistro.vue?vue&type=script&lang=js&"
export * from "./HistoricoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoRegistro.vue?vue&type=style&index=0&id=5352c806&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports